import { SimpleChanges } from "@angular/core";
import { Input } from "@angular/core";
import { Component, OnInit, OnChanges } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { GetTaskListDto } from "../../../../core/models/task-management/getTaskListDto";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { TableModule, TablePageEvent } from "primeng/table";
import { CommonModule } from "@angular/common";
import { DatePickerModule } from "primeng/datepicker";
import { DialogModule } from "primeng/dialog";
import { CardModule } from "primeng/card";
import { SpinnerComponent } from "../../spinner/spinner.component";

@UntilDestroy()
@Component({
  selector: "jni-task-calendar-view",
  templateUrl: "./task-calendar-view.component.html",
  styleUrls: ["./task-calendar-view.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    DatePickerModule,
    DialogModule,
    CardModule,
    SpinnerComponent,
  ],
})
export class TaskCalendarViewComponent implements OnInit, OnChanges {
  @Input() refreshTasks!: boolean;
  display = false;
  showSmallLoader = true;
  showUpcomingSmallLoader = true;
  todaysTask: GetTaskListDto[] = [];
  upcomingTask: GetTaskListDto[] = [];

  // Pagination
  pageSize = 10;
  first = 0;
  pageNumber = 1;
  totalRecords = 0;

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    this.getUsersTodaysTaskList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["refreshTasks"]?.currentValue) {
      this.getUsersTodaysTaskList();
    }
  }

  isPageChangeAllowed = true;
  pageChange(event: TablePageEvent) {
    if (this.isPageChangeAllowed) {
      this.isPageChangeAllowed = false;
      this.first = event.first;
      this.pageSize = event.rows;
      this.pageNumber = this.first / this.pageSize + 1;
      this.getUsersUpcomingTaskList();
    } else {
      this.isPageChangeAllowed = true;
    }
  }

  showDialog() {
    this.display = true;
  }

  getUsersTodaysTaskList() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getUserTodaysTaskList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.todaysTask = res.data || [];
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  getUsersUpcomingTaskList() {
    this.showUpcomingSmallLoader = true;

    this._taskManagementService
      .getUserUpcomingTaskList({
        pageSize: this.pageSize,
        pageNumber: this.pageNumber,
      })
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showUpcomingSmallLoader = false;
          this.upcomingTask = res.data ?? [];
          this.totalRecords = res.totalRecords ?? 0;
        },
        error: res => {
          this.showUpcomingSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }
}
